import { MediaUpload } from '@wordpress/block-editor';
import { SelectControl, Button, RangeControl } from '@wordpress/components';
import {
  MediaReplaceButton,
  MediaRemoveButton,
} from '@components/media-upload';

const {
  i18n: { __ },
} = wp;

const PauseIcon = ({ pauseBtn, setAttributes }) => {
  return (
    <>
      <span className="title-label">Pause Icon</span>
      <MediaUpload
        onSelect={(file) => {
          setAttributes({
            pauseBtn: {
              ...pauseBtn,
              id: file.id,
              title: file.title,
              filename: file.filename,
              pauseButtonImgUrl: file.url,
              fileType: file.type,
            },
          });
        }}
        type="image"
        allowedTypes={['image']}
        value={pauseBtn.pauseButtonImgUrl}
        render={({ open }) => (
          <div className="media-upload image-upload">
            {pauseBtn.pauseButtonImgUrl && (
              <div className="upload-buttons-wrapper">
                <MediaReplaceButton onClick={open} />
                <MediaRemoveButton
                  onClick={() => {
                    setAttributes({
                      pauseBtn: {
                        ...pauseBtn,
                        pauseButtonImgUrl: '',
                      },
                    });
                  }}
                />
              </div>
            )}
            {!pauseBtn.pauseButtonImgUrl && (
              <Button className="media-button upload-button" onClick={open}>
                {__('Upload Image', 'b3rg')}
              </Button>
            )}
            {pauseBtn.pauseButtonImgUrl && (
              <div
                className="image-thumb-wrapper"
                onClick={open}
                onKeyUp={open}
                role="button"
                tabIndex="0"
              >
                <img
                  className="image-thumb"
                  src={pauseBtn.pauseButtonImgUrl}
                  alt=""
                />
              </div>
            )}
          </div>
        )}
      ></MediaUpload>
      <br />
      <span className="title-label">Pause Button Size Unit</span>
      <SelectControl
        value={pauseBtn.pauseBtnUnit}
        options={[
          { label: 'Pixels', value: 'px' },
          { label: 'Percentage', value: '%' },
        ]}
        onChange={(newValue) => {
          setAttributes({
            pauseBtn: {
              ...pauseBtn,
              pauseBtnUnit: newValue,
            },
          });
        }}
      />
      <span className="title-label">Pause Button Width</span>
      <RangeControl
        value={pauseBtn.pauseButtonWidth}
        onChange={(value) => {
          setAttributes({
            pauseBtn: {
              ...pauseBtn,
              pauseButtonWidth: value,
            },
          });
        }}
        min={10}
        max={1000}
      />
      <span className="title-label">Pause Button Height</span>
      <RangeControl
        value={pauseBtn.pauseButtonHeight}
        onChange={(value) => {
          setAttributes({
            pauseBtn: {
              ...pauseBtn,
              pauseButtonHeight: value,
            },
          });
        }}
        min={10}
        max={1000}
      />
    </>
  );
};
export default PauseIcon;
